import { transport } from 'config/transport';

export function callApiExportStudents(classId) {
    return transport.get(`/mamnon/classes/${classId}/exportstudentsinfo`, { responseType: 'blob' });
}
